import React from "react";
import {
  Document,
  Page,
  View,
  Text,
  Image,
  StyleSheet,
  Font
} from "@react-pdf/renderer";

Font.register({
  family: "Exo2",
  src: "/fonts/Exo2-VariableFont_wght.ttf"
});

const styles = StyleSheet.create({

  page: {
    padding: 24,
    fontSize: 8,
    fontFamily: "Exo2"
  },

  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 15
  },

  logo: {
    width: 120
  },

  rightAlign: {
    textAlign: "right",
    fontSize: 8,
    color: "#555"
  },

  infoRow: {
    flexDirection: "row",
    flexWrap: "wrap",
    marginBottom: 15
  },

  infoItem: {
    flexDirection: "row",
    marginRight: 15,
    marginBottom: 5
  },

  bold: {
    fontWeight: "bold"
  },

  tableHeader: {
    flexDirection: "row",
    backgroundColor: "#323B98",
    color: "white",
    paddingTop: 4,
    paddingBottom: 4
  },

  tableRow: {
    flexDirection: "row",
    borderBottom: "1px solid #DDD",
    paddingTop: 3,
    paddingBottom: 3
  },

  totalRow: {
    flexDirection: "row",
    borderTop: "2px solid #666",
    borderBottom: "1px solid #666",
    paddingTop: 4,
    paddingBottom: 4
  },

  cell: {
    paddingLeft: 3,
    paddingRight: 3,
    fontSize: 8
  },

  right: {
    textAlign: "right"
  },

  center: {
    textAlign: "center"
  },

  colPeriodo: {
    width: "14%"
  },

  colInicio: {
    width: "14%"
  },

  colFin: {
    width: "14%"
  },

  colMonto: {
    width: "16%"
  },

  colPortfolio: {
    width: "10%"
  }

});

export default function PerformancePdfExport({

  performanceReponse,

  homeTrade,

  filterDate,

  filterDateHasta,

  filterComitente,

  filterManager,

  viewComitente,

  viewManager

}) {

  const formatMoney = (value) => {

    if (value === null || value === undefined)
      return "";

    return Number(value).toLocaleString("es-AR", {
      maximumFractionDigits: 0
    });

  };

  const formatPct = (value) => {

    if (value === null || value === undefined)
      return "";

    return (Number(value) * 100).toLocaleString("es-AR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + "%";

  };

  const formatDate = (value) => {

    if (!value)
      return "";

    const p = value.split("-");

    return `${p[2]}/${p[1]}/${p[0]}`;

  };

  const now = new Date().toLocaleString("es-AR", {

    day: "2-digit",

    month: "2-digit",

    year: "numeric",

    hour: "2-digit",

    minute: "2-digit"

  });

  return (

    <Document>

      <Page
        size="A4"
        style={styles.page}
      >

        <View style={styles.header}>

          <Image
            src="/img/winvest.png"
            style={styles.logo}
          />

          <Text style={styles.rightAlign}>
            {now}
          </Text>

        </View>

        <View style={styles.infoRow}>

          <View style={styles.infoItem}>
            <Text style={styles.bold}>Moneda:</Text>
            <Text> {homeTrade.toUpperCase()}</Text>
          </View>

          <View style={styles.infoItem}>
            <Text style={styles.bold}>Desde:</Text>
            <Text> {formatDate(filterDate)}</Text>
          </View>

          <View style={styles.infoItem}>
            <Text style={styles.bold}>Hasta:</Text>
            <Text> {formatDate(filterDateHasta)}</Text>
          </View>

          {viewComitente && filterComitente && (

            <View style={styles.infoItem}>
              <Text style={styles.bold}>Cuenta:</Text>
              <Text> {filterComitente.label}</Text>
            </View>

          )}

          {viewManager && filterManager && (

            <View style={styles.infoItem}>
              <Text style={styles.bold}>Agente:</Text>
              <Text> {filterManager.label}</Text>
            </View>

          )}

        </View>

        <View style={styles.tableHeader}>

          <Text style={[styles.cell, styles.colPeriodo]}>
            Periodo
          </Text>

          <Text style={[styles.cell, styles.colInicio]}>
            Inicio
          </Text>

          <Text style={[styles.cell, styles.colFin]}>
            Fin
          </Text>

          <Text style={[styles.cell, styles.colMonto, styles.right]}>
            Posición
          </Text>

          <Text style={[styles.cell, styles.colMonto, styles.right]}>
            Contribución
          </Text>

          <Text style={[styles.cell, styles.colMonto, styles.right]}>
            Cambio
          </Text>

          <Text style={[styles.cell, styles.colPortfolio, styles.right]}>
            Portfolio %
          </Text>

        </View>
        {performanceReponse.map((item, index) => {

          const endValue =
            homeTrade === "ars"
              ? item.endFx
              : item.endUsd;

          const netValue =
            homeTrade === "ars"
              ? item.netFx
              : item.netUsd;

          const changeValue =
            homeTrade === "ars"
              ? item.changeFx
              : item.changeUsd;

          const pctValue =
            homeTrade === "ars"
              ? item.pctFx
              : item.pctUsd;

          const isTotal =
            item.period &&
            item.period.toString().toLowerCase() === "total";

          return (

            <View
              key={index}
              style={isTotal ? styles.totalRow : styles.tableRow}
            >

              <Text
                style={[
                  styles.cell,
                  styles.colPeriodo,
                  isTotal && styles.bold
                ]}
              >
                {item.period}
              </Text>

              <Text
                style={[
                  styles.cell,
                  styles.colInicio
                ]}
              >
                {formatDate(item.periodStart)}
              </Text>

              <Text
                style={[
                  styles.cell,
                  styles.colFin
                ]}
              >
                {formatDate(item.periodEnd)}
              </Text>

              <Text
                style={[
                  styles.cell,
                  styles.colMonto,
                  styles.right,
                  Number(endValue) < 0 && {
                    color: "red"
                  }
                ]}
              >
                {formatMoney(endValue)}
              </Text>

              <Text
                style={[
                  styles.cell,
                  styles.colMonto,
                  styles.right,
                  Number(netValue) < 0 && {
                    color: "red"
                  }
                ]}
              >
                {formatMoney(netValue)}
              </Text>

              <Text
                style={[
                  styles.cell,
                  styles.colMonto,
                  styles.right,
                  Number(changeValue) < 0 && {
                    color: "red"
                  }
                ]}
              >
                {formatMoney(changeValue)}
              </Text>

              <Text
                style={[
                  styles.cell,
                  styles.colPortfolio,
                  styles.right,
                  Number(pctValue) < 0 && {
                    color: "red"
                  }
                ]}
              >
                {formatPct(pctValue)}
              </Text>



            </View>

          );

        })}

        <Text style={{ marginTop: '10px' }}></Text>
        <Text style={{ margin: '2px 0' }}>
          Los saldos e información contenidos en el presente revisten carácter informativo y se encuentran sujetos a verificación.
        </Text>
        <Text style={{ margin: '2px 0' }}>
          Salvo Error u Omisión (S.E.U.O.).
        </Text>
        <Text style={{ margin: '2px 0' }}>
          La documentación respaldatoria de las operaciones se encuentra a disposición del cliente conforme la normativa vigente de la CNV (Título VII, Capítulo II T.O.).
        </Text>

      </Page>

    </Document>

  );

}